// i18n.js
import { translations } from "./language";

export const getTranslation = (lang, key) => {
  return translations[lang][key] || key;
};
